import { render, staticRenderFns } from "./GraphDetail24.vue?vue&type=template&id=2a35b5e6&scoped=true"
import script from "./GraphDetail24.vue?vue&type=script&lang=js"
export * from "./GraphDetail24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a35b5e6",
  null
  
)

export default component.exports